<template>
  <div>
    <v-row class="px-5 mt-5" no-gutters> BreadCrumbs </v-row>
    <v-row class="px-5" no-gutters > 
      <a-breadcrumbs
        :items="items"
        style="border-bottom: 1px solid var(--v-secondary-base);"
      >
        <template v-slot:divider>
          <v-icon size="22" color="neutralGray">mdi-menu-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            href=""
            :class="item.disabled ? 'disabled-text' : 'primary--text'"
            style="cursor: pointer"
          >
            <span style=" font-weight: 400; font-size: 14px;">
              {{ item.text }}</span
            >
          </v-breadcrumbs-item>
        </template>
      </a-breadcrumbs>
    </v-row>
  </div>  
</template>

<script>
import ABreadcrumbs from './ABreadcrumbs.vue';
export default {
  name: "BreadcrumbsSample",
  components: {
    ABreadcrumbs
  },
  data() {
    return {
      items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Link 1',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Link 2',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
    }
  }
}
</script>

<style>

</style>